import React from 'react'
import Helmet from 'react-helmet'
import { useIntl } from 'react-intl'
import Layout from 'components/Layout/Layout'
import StatusRecordsPanel from 'components/StatusRecordsPanel/StatusRecordsPanel'

const StatusRecords = () => {
  const title = useIntl().formatMessage({ id: 'StatusRecords.title' }, { 0: process.env.REACT_APP_PAGE_TITLE })

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Layout>
        <StatusRecordsPanel />
      </Layout>
    </>
  )
}

export default StatusRecords
